import { I18n } from '@front/volcanion'
import FormatUtils from '@front/squirtle/utils/format'

import Aux from './Aux'

class Callbacks {
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        contact: {
          gsm: record?.contact?.gsm,
          email: record?.contact?.email,
          first_name: record?.contact?.first_name,
          last_name: record?.contact?.last_name
        },
        identifier: record?.identifier,
        pin: record?.pin,
        status: FormatUtils.getStatus(_.pick(record, ['active', 'deleted', 'suspendedUntil', 'suspendedSince'])),
        companycontract: record?.companycontract,
        deferred_billing: record?.deferred_billing,
        availableSince: record?.availableSince,
        availableUntil: record?.availableUntil,
        self_booking: record?.self_booking,
        booking_level: record?.booking_level,
        guest_booking: record?.guest_booking,
        administration_level: record?.administration_level,
        update: record?.update,
        blacklisted_domains: _.map(record?.blacklisted_domains, 'domain_id'),
        companyuser_services: _.map(record?.companyuser_services, elem => ({
          companyuserservice_id: elem?.companyuserservice_id,
          companycontract: elem?.companyservice?.contract,
          companyservice: elem?.companyservice?.companyservice_id
        })),
        exluded_commercial_packages: _.map(record?.exluded_commercial_packages, 'commercial_package_id'),
        priority: record?.priority
      }
    }
  }

  static getEmptyFormHandler() {
    return function getEmptyFormValues() {
      return {
        self_booking: true,
        guest_booking: false,
        status: 'active',
      }
    }
  }

  static formToRecordHandler(company, application) {
    return function formToRecord(values, extra, meta, { suspended, ...state }) {
      const current_status = _.find(meta, ['field', 'status'])?.initial
      return _.merge(
        !state?.user_id ? {
          user: {
            auth: {
              gsm: values?.contact?.gsm,
              application,
              user_type: 'booker'
            },
            customerinfo: {},
            info: {
              first_name: values?.contact?.first_name,
              last_name: values?.contact?.last_name,
            },
          }
        } : { user: state.user_id },
        {
          contact: {
            gsm: values?.contact?.gsm,
            email: values?.contact?.email,
            first_name: values?.contact?.first_name,
            last_name: values?.contact?.last_name
          },
          companycontract: values?.companycontract,
          deferred_billing: values?.deferred_billing,
          availableSince: Aux.exportDate(values?.availableSince),
          availableUntil: Aux.exportDate(values?.availableUntil),
          self_booking: values?.self_booking,
          booking_level: values?.booking_level,
          guest_booking: values?.guest_booking,
          administration_level: values?.administration_level,
          update: values?.update,
          blacklisted_domains: _.has(values, 'blacklisted_domains')
            ? values?.blacklisted_domains
            : undefined,
          companyuser_services: _.has(values, 'companyuser_services')
            ? _.map(_.compact(values?.companyuser_services), elem => ({
              company,
              companyservice: elem?.companyservice
            }))
            : undefined,
          company,
          status: FormatUtils.parseStatus(values?.status || current_status, _.pick(suspended, ['suspendedUntil', 'suspendedSince', 'motive'])),
          exluded_commercial_packages: values?.exluded_commercial_packages,
          priority: values?.priority
        })
    }
  }

  static recordToStateHandler() {
    return function recordToState(record) {
      return {
        title: record?.user?.customerinfo?.client_number,
        company: record?.company,
        user_id: record?.user?.user_id,
        suspended: {
          suspendedUntil: record?.suspendedUntil,
          suspendedSince: record?.suspendedSince,
          motive: record?.motive
        }
      }
    }
  }

  static formToOptionsHandler() {
    return function formToOptions(values, extra, meta, state) {
      return { force_order_cancel: !!extra?.forceSubmit }
    }
  }

  static onSubmitSuccessHandler(requestSubmitOrderLimit) {
    return async function onSubmitSuccess(result, values, extra, meta) {
      !!requestSubmitOrderLimit && requestSubmitOrderLimit({ companyuser: result?.companyuser_id })
      console.log("🚀 ~ file: callbacks.js ~ line 27 ~ Callbacks ~ onSubmitSuccess ~ result, values, extra, meta", result, values, extra, meta)
    }
  }

  static onSubmitFailedHandler(openDialog) {
    return async function onSubmitFailed(err, values, extra, meta) {
      if (err?.code === 'ACTIVE_JOBS')
        openDialog('show_active_jobs', {
          title: I18n.t('driver.popup.show_active_jobs.pending_orders.title'),
          description: I18n.t('driver.popup.show_active_jobs.pending_orders.description', { entity: I18n.t('driver.popup.show_active_jobs.entity.companyuser') }),
          job_ids: err?.context?.job_ids,
        })
    }
  }

  static getFailedNotificationHandler() {
    return function getFailedNotification(err, values, extra, meta) {
      if (_.includes(['RECORD_EXISTS'], err.getCode())) {
        return [I18n.t('companyuser.record_exists'), { variant: 'error' }]
      }
    }
  }
  static handleOnConfirmSendIdentifier(companyuser_id, sendIndentifier, openNotification) {
    return async function onConfirmSendIdentifier() {
      try {
        await sendIndentifier({ companyuser_id })
        openNotification(I18n.t('companyuser.popup.send_identifier.success'), { variant: 'success' })
      } catch (err) {
        if (_.includes(['NO_IDENTIFIER', 'NO_EMAIL', 'MISSING_ARGUMENTS'], err?.getCode()))
          openNotification(I18n.t('companyuser.popup.send_identifier.error'), { variant: 'error' })
        else
          openNotification(I18n.t('error.unknow'), { variant: 'error' })
      }
    }
  }
  static handleOpenSendIdentifierDialog(openDialog, onConfirmSendIdentifier) {
    return function openSendIdentifierDialog() {
      openDialog('confirmation_dialog', {
        title: I18n.t('companyuser.popup.send_identifier.title'),
        description: I18n.t('companyuser.popup.send_identifier.description'),
        onConfirm: onConfirmSendIdentifier
      })
    }
  }
}

export default Callbacks
